var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 3873 3873",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 893.542,
    x2: 2852.313,
    y1: 928.233,
    y2: 2887.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc00ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00dbde"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M2845.2 1727c0 187.1-140.5 342.3-323.1 363.7v-727.4c182.8 21.5 323.1 176.9 323.1 363.7zM502.4 2063.4l214.8 1113.3h304.3c-9.8-51-212.5-1101-214.8-1113.3zM799 1456.3H471.9c-141.9 0-258.2 116.3-258.2 258.2s116.3 258.2 258.2 258.2H799zm1462.7-748.4c-93.2 0-169.7 76.4-169.7 169.7v1698.8c0 93.2 76.5 169.7 169.7 169.7s169.7-76.5 169.7-169.7V877.6c0-93.2-76.4-169.7-169.7-169.7zm-1372 746.3v520.6c615.9 32.4 964.5 344 1111.7 516.3V938c-147.2 172.2-495.8 483.9-1111.7 516.2zm71.3 931.2h260.9V2116c-97.2-25.2-204.6-42.9-322.5-50zm2608-805.3h-290c-52.2 0-94.5 42.3-94.5 94.5s42.3 94.5 94.5 94.5h290c52.2 0 94.5-42.3 94.5-94.5s-42.3-94.5-94.5-94.5zm-86 508.5-251.1-145c-45-25.9-102.5-10.3-128.4 34.7s-10.3 102.5 34.7 128.4l251.1 145c45 25.9 102.5 10.3 128.4-34.7s10.3-102.5-34.7-128.4zm-251-682.9 251.1-145c45-25.9 60.6-83.4 34.7-128.4s-83.4-60.6-128.4-34.7l-251.1 145c-45 25.9-60.6 83.4-34.7 128.4s83.4 60.6 128.4 34.7z",
    opacity: 1,
    "data-original": "url(#a)",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.c43c05880bb892a05b04eef01c04d2b6.svg";
export { ForwardRef as ReactComponent };